<template>
  <div class="page-top">
    <div class="header-box clearFix">
      <div class="header-l-box floatl">
        <img v-if="LogoSrc" class="header-logo" v-bind:src="LogoSrc" alt="Logo">
        <img v-else class="header-logo" src="~@img/stkLogo2.png" alt="Logo">
        <!-- http://static.cakeboss.com.cn/stkLogo2.png -->
      </div>
      <div class="floatr header-r-box" style="width: 52%;">
       
        <el-autocomplete 
          class="input-with-select head-select" 
          v-model="searchVal" 
          placeholder="请输入产品名称或产品货号"  
          @keyup.enter.native="show($event)"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"

        >
          <template slot="prepend" >产品搜索
            <!-- <el-option v-for="item in searchOptions" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
          </template>
          <el-button @click="confirmSearch"  slot="append" icon="el-icon-search"></el-button>
        </el-autocomplete>
         <div class="long" v-if="!stkMessage">
          <router-link to="/login">登录/注册</router-link>
        </div>
        <div class="long" v-else>
          <el-dropdown>
            <span class="el-dropdown-link">
                                {{stkMessage.userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link to="/pc/order-list">订单列表</router-link>
              </el-dropdown-item>
              <el-dropdown-item command="a">
                <div @click="toLogin">退出</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="nav-box">
      <div>
        <router-link to="/pc/index">首页</router-link>
        <router-link to="/pc/product">产品列表</router-link>
        <router-link to="/pc/order-cart">购物车</router-link>
        <router-link to="/pc/agent-brand">代理品牌</router-link>
        <router-link to="/pc/about-our">关于我们</router-link>
        <router-link to="/pc/news-center">新闻中心</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    post,
    get
  } from '@/axios/index';
  export default {
    props: ['LogoSrc'],
    data() {
      return {
        stkMessage: JSON.parse(localStorage.getItem('stkMessage')) || '',
        searchVal: "",
        restaurants: [],
        state4: '',
        timeout:  null
      }
    },
    methods: {
      //退出登录
      toLogin() {
        localStorage.removeItem('stkMessage');
        this.$router.push({
          path: '/login'
        })
      },
      //顶部搜索，确认搜索
      confirmSearch() {
        let productName;
        let orderNo;
        this.$store.commit("changeProductName");
        console.log(this.$route.path, "route.path");
       productName = this.searchVal;
        this.$router.push({
          path: "/pc/product",
          query: {
            productName: productName,
          }
        })
      },
       //顶部搜索，确认搜索
      show(ev) {
        if(ev.keyCode == 13){
           let productName;
        let orderNo;
        this.$store.commit("changeProductName");
        console.log(this.$route.path, "route.path");
       productName = this.searchVal;
       console.log('102',this.searchVal);
        this.$router.push({
          path: "/pc/product",
          query: {
            productName: productName,
          }
        })
      }
      },
      loadAll() {
      get("/stkproductinfo/getlistbystatusandtype", {
      })
        .then(res => {
          this.restaurants = res.data.result.pageData;
        })
        .catch(err => {
          this.loading = false;
        });
      },
      querySearchAsync(queryString, cb) {
         console.log("aaaaa====="+ queryString)
        if(queryString == '') {
          return ;
        }
        get('/stkproductinfo/getlistbyname',{productNameFuzzy:queryString})
        .then(res => {
          var results = queryString ? res.data.result.filter(this.createStateFilter(queryString)) : res.data.result;
          results = results.map(item => {
            item.value = item.name;
            return item;
          })
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
        })
      },
      createStateFilter(queryString) {
        return (state) => {
          console.log(state);
            state.value = state.name;
          return state;
        };
      },

      // 下拉框选择
      handleSelect(item) {
        console.log(item);
        this.$store.commit("changeProductName");
        let productName = item.value;
        console.log(productName);
        this.$router.push({
          path: "/pc/product",
          query: {
            productName: productName,
          }
        })
      }
    },
    mounted() {
      // this.loadAll();
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .head-select>.el-input__inner {
    height: 25px;
    margin-top: 1px;
  }
  .header-logo{
    width: 165px;
  }
  .router-link-active {
    border-bottom: 3px solid #ffffff;
  }
  .long{
    padding-left: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue